const $ = require('jquery');


//---------------------------------------------------
// JS for the Search Modal popup
//---------------------------------------------------

// Some shortcut variables first
let searchIcon = $('header .tools .search-btn');

// Quickly prepend a title
$('#block-exposedformsearchpage-1 form').prepend('<h2>Start Your Search</h2>');

// Quickly prepend in the textual "exit" link element
$('#block-exposedformsearchpage-1 #edit-actions').append('<span class="close-search-modal">Exit Search</span>');

// Quickly add the required attribute to the hidden search box
$('#block-exposedformsearchpage-1 #edit-filter').attr('required','required');

// Open the Search Modal when the main nav's search tool icon is clicked
searchIcon.on('click', function(e) {
  e.preventDefault();
  //$(this).children('span').removeClass('icon-search').addClass('icon-close');
  $('#main-page-wrapper').toggleClass('has-modal-open');
  $('#search-modal').slideDown(300);
  $('#block-exposedformsearchpage-1 #edit-filter').focus();
  return false;
});

// Close the Search Modal when the "close X icon" or the "Exit Search link" is clicked
$("#block-exposedformsearchpage-1 form .close-search-modal, #search-modal .close-search-modal-x").on('click', function(e) {
  e.preventDefault();
  //searchIcon.children('span').removeClass('icon-close').addClass('icon-search');
  $('#main-page-wrapper').toggleClass('has-modal-open');
  $('#search-modal').slideUp(300);
  return false;
});

// Also allow closing of the modal by clicking outside of the form area
$('#search-modal').on('click', function(e) {
  // if the target click is anywhere on the modal that is NOT the dimmed out area, then do nothing with the function
  if (e.target !== this) {
    return;
  }

  // otherwise, slide up the modal and reset the wrapper class
  $(this).slideUp(300);
  $('#main-page-wrapper').toggleClass('has-modal-open');
  //searchIcon.children('span').removeClass('icon-close').addClass('icon-search');
});




//---------------------------------------------------
// JS for Cloning the Search bar into the mobile menu
//---------------------------------------------------

let mobileSearchBuilt = false;

function buildMobileSearch() {

  // When the hamburger icon is clicked on, remove the resize listener
  $('.mobile-only-header').on('click', function() {
    $(window).off('resize');
  });

  if ((window.innerWidth < 480) && !mobileSearchBuilt) {

    // create empty element container
    //$('.main-menu').append('<div id="mobile-search-container"></div>');
    $('<div id="mobile-search-container"></div>').insertAfter('header .menu');
    // clone and append search to new element
    $('#search-modal form#views-exposed-form-search-page-1').clone().appendTo('#mobile-search-container');
    // remove pieces we don't need
    $('#mobile-search-container h2').remove();
    $('#mobile-search-container .close-search-modal').remove();
    $('#mobile-search-container label').remove();
    $('#mobile-search-container .form-actions').remove();
    // change the placeholder text
    $('#mobile-search-container .form-text').attr('placeholder', 'Search');

    mobileSearchBuilt = true;

  } else {
    $('#mobile-search-container').remove();
    mobileSearchBuilt = false;
  }

}

// run immediately only if viewport is below 600px
if (window.innerWidth < 480) {
  buildMobileSearch();
}
// re-run as the browser re-sizes
$(window).resize(buildMobileSearch);
